// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__pVhE2","vLegacy":"SelectSecondary_vLegacy__a7nop","error":"SelectSecondary_error__2BdOy","disabled":"SelectSecondary_disabled__1Grec"};